import { render, staticRenderFns } from "./IconUploadBig.vue?vue&type=template&id=fed3e12e&"
import script from "./IconUploadBig.vue?vue&type=script&lang=js&"
export * from "./IconUploadBig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fed3e12e')) {
      api.createRecord('fed3e12e', component.options)
    } else {
      api.reload('fed3e12e', component.options)
    }
    module.hot.accept("./IconUploadBig.vue?vue&type=template&id=fed3e12e&", function () {
      api.rerender('fed3e12e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconUploadBig.vue"
export default component.exports